// import createPersistedState from 'vuex-persistedstate'
import * as apiProfile from '@/api/profile'
import * as apiCommon from '@/api/common'
import { getDataURL } from '@/util/common'

const profile = {
  // plugins: [createPersistedState({ key: 'lc-app' })], // LocalStorageに保存する場合はコメント解除
  namespaced: true,
  state: {
    id: null,
    identification_code: null, // 契約識別コード
    integrated_user_id: null, // 統合ユーザーID
    name: '',
    email: '',
    login_type: null,
    auth: null,
    product_name_lists: [],
    alert_flg: null,
    alert_tags: [],
    alert_books: [],
    user_icon: null,
    user_icon_image: null,
    template: null,
    type: null,
    book_revision_id: [], // 先例・判例書籍リビジョンIDリスト
    last_update_time: null, // 更新日時
    organization_id: null // 組織ID
  },
  getters: {
    /**
     * @return {boolean} true:管理者, false:一般
     */
    isAdmin: (state) => state.auth === 1,
    /**
     * @return {boolean} true:アカウントログイン, false:その他
     */
    isAccountLogin: (state) => state.login_type === 3,
    /**
     * @return {boolean} true:WLJOP会員, false:その他
     */
    isWLJOP: (state) => state.type === 2 || state.type === 6
  },
  mutations: {
    setProfile: (status, data) => {
      if (data.user_icon === '') {
        data.user_icon = null
      }
      if (!data.user_icon) {
        data.user_icon_image = null
      }
      status = Object.assign(status, data)
    },
    setUserImage: (status, image) => {
      status.user_icon_image = image
    },
    setAlertFlg(state, alertFlg) {
      state.alert_flg = alertFlg
    },
    setAlertBooks(state, alertBooks) {
      state.alert_books = alertBooks
    },
    setAlertTags(state, alertTags) {
      state.alert_tags = alertTags
    },
    setTemplate(state, template) {
      state.template = template
    },
    setUserId(state, id) {
      state.id = id
    },
    setLastUpdateTime(state, lastUpdateTime) {
      state.last_update_time = lastUpdateTime
    },
    setOrganizationId(state, organizationId) {
      state.organization_id = organizationId
    }
  },
  actions: {
    setProfile({ commit }, data) {
      commit('setProfile', data)
    },

    /**
     * プロフィール取得API
     * @param {} コンテキストの分割代入
     * @param {} ペイロード
     */
    async fetch({ commit }, params) {

      const result = {}

      await apiProfile.fetch(params) 
        .then(response => {
          const data = response.data
          if (data.status === 0) {

            const saved = { ...data }
            delete saved.status
            delete saved.error_message
            commit('setProfile', saved)
          } else {
          }

          result.response = response
        })
        .catch(error => {
          result.error = error
        })

      return result
    },
    async getUserImage({ state, commit, dispatch }) {
      // awati apiCommon.
      if (state.user_icon) {

        dispatch('getFile', state.user_icon, { root: true }).then(res => {
          commit('setUserImage', res.dataUrl)
        })
      }
    },
    setAlertFlg({ commit }, alertFlg) {
      commit('setAlertFlg', alertFlg)
    },
    setAlertBooks({ commit }, alertBooks) {
      commit('setAlertBooks', alertBooks)
    },
    setAlertTags({ commit }, alertTags) {
      commit('setAlertTags', alertTags)
    },
    setTemplate({ commit }, template) {
      commit('setTemplate', template)
    },
    setOrganizationId({ commit }, organizationId) {
      commit('setOrganizationId', organizationId)
    },
    setUserId({ commit }, id) {
      commit('setUserId', id)
    },
    setLastUpdateTime({ commit }, lastUpdateTime) {
      commit('setLastUpdateTime', lastUpdateTime)
    }
  }
}

export default profile
